import React from 'react';
import { MarketButton, MarketButtonGroup, MarketDialog, MarketFooter, MarketHeader } from '@market/react';
import { getIntlString } from '@goparrot-dashboard/i18n';
import { DialogStateReturn } from './DialogStateReturn';

type Props = {
  dialog: DialogStateReturn;
  onCancel?: () => void;
  handleDelete: () => void;
  title: string;
  dialogText: string | JSX.Element;
  isDeleting?: boolean;
  deleteText?: string;
  cancelText?: string;
  callOnCancelOnDialogDismissed?: boolean;
  className?: string;
};

export const DeleteConfirmModal: React.FC<React.PropsWithChildren<Props>> = ({
  dialog,
  handleDelete,
  onCancel,
  dialogText,
  title,
  isDeleting,
  deleteText = getIntlString('button.delete'),
  cancelText = getIntlString('button.cancel'),
  className,
}) => {
  const { visible, dialogRef, dismiss } = dialog;

  const handleCancel = () => {
    dismiss();
    onCancel?.();
  };

  return visible ? (
    <MarketDialog className={className} onMarketDialogDismissed={handleCancel} ref={dialogRef}>
      <MarketHeader>
        <h2 className="tw-mb-0" data-testid="remove-confirmation-modal-header">
          {title}
        </h2>
      </MarketHeader>
      <section className="main">
        <p className="tw-mb-0" data-testid="remove-confirmation-modal-content">
          {dialogText}
        </p>
      </section>
      <MarketFooter data-testid="remove-confirmation-modal-footer">
        <MarketButtonGroup alignment="fill">
          <MarketButton rank="primary" variant="destructive" onClick={handleDelete} isLoading={isDeleting || undefined}>
            {deleteText}
          </MarketButton>
          <MarketButton rank="secondary" onClick={onCancel || dismiss}>
            {cancelText}
          </MarketButton>
        </MarketButtonGroup>
      </MarketFooter>
    </MarketDialog>
  ) : null;
};
